export enum AssignmentActionType {
  ADD,
  REMOVE,
}
